import { gql } from "@apollo/client";

const EventsQueryHi = gql`
  query MyQuery {
    nodeEvents(first: 100, langcode: "hi") {
      nodes {
        id
        path
        created {
         time
        }
        title
        __typename
        imageAbout {
          url
          alt
        }
        body {
          value
        }
        commonBanner {
          ... on MediaCommonBanner {
            id
            name
            mediaImage2 {
              url
              alt
            }
          }
        }
      }
    }
  }
`;

export default EventsQueryHi;
